<div class="row">
  <span class="col-4">
    <span class="label">{{ formUnitLabel }}</span>
    <i (click)="resetQuantities()" class="icon-reset icon icon--clickable"></i>
  </span>
  <div class="col-8">
    <div class="input">
      <lib-input-number
        [ngModel]="bomQuantity"
        (ngModelChange)="bomQuantityChanged($event)"
        [min]="INPUT_MIN_NUMBER"
        [inputStyle]="INPUT_STYLE"
        [unit]="bomUnitId"
        [disabled]="disabled"
      ></lib-input-number>
    </div>
    <div class="input" *ngIf="isInventoryUnitDisplayed">
      <lib-input-number
        [ngModel]="formInventoryQuantity"
        (ngModelChange)="inventoryQuantityChanged($event)"
        [disabled]="disabled"
        [min]="INPUT_MIN_NUMBER"
        [inputStyle]="INPUT_STYLE"
        [unit]="inventoryUnitId"
      ></lib-input-number>
    </div>
    <div class="input" *ngIf="isHeightDisplay">
      <lib-input-number
        [ngModel]="height"
        (ngModelChange)="heightChanged($event)"
        [disabled]="disabled"
        [min]="INPUT_MIN_NUMBER"
        [inputStyle]="INPUT_STYLE"
        [unit]="'mm'"
      ></lib-input-number>
    </div>
    <div class="input" *ngIf="isReelDiameterDisplay">
      <lib-input-number
        [ngModel]="outerCoreDiameter"
        (ngModelChange)="countReelDiameterOnCoreDiameterChange($event)"
        [disabled]="disabled"
        [min]="INPUT_MIN_NUMBER"
        [inputStyle]="INPUT_STYLE"
        [unit]="'mm core diameter'"
      ></lib-input-number>
    </div>
    <div class="input" *ngIf="isReelDiameterDisplay">
      <lib-input-number
        [ngModel]="outerReelDiameter"
        (ngModelChange)="countReelDiameterOnReelDiameterChange($event)"
        [disabled]="disabled"
        [min]="INPUT_MIN_NUMBER"
        [inputStyle]="INPUT_STYLE"
        [unit]="'mm reel diameter'"
      ></lib-input-number>
      <div *ngIf="!isDiameterInputValid" class="warning-message">Core Diameter must be less than Reel Diameter.</div>
    </div>
  </div>
</div>
